import { render, staticRenderFns } from "./default.vue?vue&type=template&id=cebdfb4a&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FooterMobile: require('/opt/buildhome/repo/components/footer-mobile/index.vue').default,Share: require('/opt/buildhome/repo/components/global/share/index.vue').default,ReportAbuse: require('/opt/buildhome/repo/components/global/report-abuse/index.vue').default,BlockUser: require('/opt/buildhome/repo/components/global/block-user/index.vue').default,NotificationSubscriber: require('/opt/buildhome/repo/components/notification/NotificationSubscriber.vue').default})
